<template>
  <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.08398 10.5834L2.07357 6.00004L6.08398 1.41671" stroke="#828282" stroke-width="2"/>
  </svg>
</template>

<script>
export default {
  name: "IconLeft"
}
</script>
